import axios from 'axios';
import qs from 'qs';
import Cookies from 'js-cookie';
import { buildServiceUrl } from '../config';

const axiosInstance = axios.create({
    paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true });
    },
});

axiosInstance.defaults.headers.common['x-lang'] = 'eng';

axiosInstance.interceptors.request.use(
    config => {
        const token = Cookies.get('obs-token');

        if (token !== undefined) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        const RISK_PROXY_SERVICE_URL = buildServiceUrl(
            process.env.REACT_APP_RISK_PROXY_SERVICE_PREFIX,
            process.env.REACT_APP_RISK_PROXY_SERVICE_SUFFIX,
        );

        if (config.url?.startsWith(RISK_PROXY_SERVICE_URL)) {
            config.withCredentials = true;
        }

        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

export default axiosInstance;
